import {makeStyles} from '@material-ui/core/styles'
import {EditModeButton, FeedbackSnackbar} from '../../1elements'
import {useState} from 'react'
import Colors from '../../../styling/Colors'
import UploadAvatarModal from '../../3modules/UploadAvatarModal/UploadAvatarModal'
import AccountAvatar from '../../3modules/TabWidgets/accountDetail/AccountAvatar'

const PersonAvatar = ({editMode, className, name, avatar, userId, onSave}) => {
    const classes = useStyles({editMode})
    const [onEditMode, setOnEditMode] = useState(false)
    const [snackbar, setSnackbar] = useState({severity: 'success', isOpen: false, message: 'Image has been added to the person'})


    return (
        <div className={`${className} ${classes.root}`}>
            <AccountAvatar avatar={avatar} accountName={name}/>

            {editMode && (
                <>
                    <EditModeButton onEditMode={onEditMode} setOnEditMode={setOnEditMode} className={classes.editIconButton} />
                    <div className={classes.greyBackground} />
                </>
            )}
            <UploadAvatarModal onEditMode={onEditMode} setOnEditMode={setOnEditMode} existingAvatar={avatar} userId={userId} setSnackbar={setSnackbar} onSave={onSave} />
            <FeedbackSnackbar snackbar={snackbar} setSnackbar={setSnackbar} />
        </div>
    )
}

export default PersonAvatar

const useStyles = makeStyles(()=>({
    root: {
        position: 'relative',
        margin: '0 0 10px 0'
    },
    greyBackground: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: Colors.DARK_GREY, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
        borderRadius: '50%',
        opacity: .3,
        zIndex: 2
    },
    editIconButton: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: Colors.MEDIUM_GREY, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
        borderRadius: '50%',
        zIndex: 3
    }
}))
